( function( $, document ) {
    'use strict';

    $( document ).ready( function() {
        //---------------------------------------------------------------------------
        //	Gated Files
        //---------------------------------------------------------------------------
        var file_link = '';
        var button_html = '';
        var cookie_expiry = 1;

        $('.js-gated-file').on( 'click', function(e) {

            if ( !Cookies.get('gated-pass') ) {
                e.preventDefault();
                file_link = $(this).prop('href');

                $('.js-file-link').find('input').val(file_link);

                $.fancybox.open({
                    src  : '#gated-content',
                    type : 'inline'
                });
            }
        } );

        function getParameterByName(name, url) {
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }

        var url = window.location.href;
        var button_link = getParameterByName('file', url);
        var set_cookie = getParameterByName('cookie', url);

        if ( set_cookie ) {
            Cookies.set('gated-pass', 'true', { expires: cookie_expiry });
        }

        if ( button_link ) {
            $( '.js-gated-content' ).append('<a href="' + button_link + '" class="btn btn-md style-2" target="_blank">Download File</a>');
        }
    } );

} )( jQuery, document );
